import React from 'react';

import { clsx } from 'clsx';

import styles from './Dots.scss';

type Props = {
  selectedIndex: number;
};

const dotsArray = [...Array(3)];

const Dots = ({ selectedIndex }: Props) => {
  return (
    <div className={styles.dots}>
      {dotsArray.map((_, index) => (
        <div
          key={index}
          className={clsx(styles.dot, styles[`${index === selectedIndex && 'selected'}`])}
        />
      ))}
    </div>
  );
};

export default Dots;
